var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jitsi-wrapper"},[_c('div',{ref:"jitsiContainer",staticClass:"jitsi-container"},[_vm._m(0)]),_c('button',{on:{"click":_vm.activatePiP}},[_vm._v("Activer PiP")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-overlay"},[_c('img',{attrs:{"src":require("../../assets/img/logo_symbiofi.png"),"alt":"Votre logo"}})])
}]

export { render, staticRenderFns }